import { useState } from "react";
import Header from "../components/Header";
import { NoticeRegion } from "../lib/notices";
import { DataTable, LoadingBlock, Section, StatCard, Tabs, TabPanel, useAdminResource } from "../components/admin/AdminUI";
import UsersPanel from "../components/admin/UsersPanel";
import RevenuePanel from "../components/admin/RevenuePanel";
import SecurityPanel from "../components/admin/SecurityPanel";
import OpsPanel from "../components/admin/OpsPanel";
import AuditPanel from "../components/admin/AuditPanel";
import WaitlistPanel from "../components/admin/WaitlistPanel";
import { formatDateTime } from "../lib/datetime";

const TABS = [
  { id: "overview", label: "Overview" },
  { id: "users", label: "Users" },
  { id: "revenue", label: "Revenue" },
  { id: "security", label: "Security" },
  { id: "ops", label: "Operations" },
  { id: "audit", label: "Audit" },
  { id: "waitlist", label: "Waitlist" },
];

function Overview() {
  const { data: stats, loading, error } = useAdminResource("/admin/stats");
  if (loading) return <LoadingBlock label="Loading overview" />;
  if (error) {
    return (
      <div className="brutal-card p-6 text-ink-accent text-sm" role="alert">
        {error} — set <code className="font-mono-ui">ADMIN_EMAILS</code> to your address and restart the backend.
      </div>
    );
  }
  return (
    <>
      <Section id="totals" title="// AT A GLANCE">
        <div className="grid md:grid-cols-3 gap-4">
          <StatCard label="Users" value={stats.total_users} testid="stat-users" />
          <StatCard label="Projects" value={stats.total_projects} />
          <StatCard label="Ready" value={stats.ready_projects} tone="good" />
          <StatCard label="In progress" value={stats.in_progress_jobs} />
          <StatCard label="Failed" value={stats.failed_projects}
                    tone={stats.failed_projects > 0 ? "bad" : "default"} />
          <StatCard label="Renders (month)" value={stats.monthly_renders} />
        </div>
      </Section>

      <Section id="recent" title="// RECENT PROJECTS">
        <DataTable
          caption="Recently updated projects, newest first"
          empty="No projects yet."
          columns={[{ key: "title", label: "Title" }, { key: "status", label: "Status" },
                    { key: "created", label: "Created" }]}
          rows={stats.recent_activity}
          renderRow={(p) => (
            <tr key={p.project_id} className="border-t border-rule">
              <td className="p-3">{p.title}</td>
              <td className="p-3"><span className={`status-dot status-${p.status}`} /> {p.status}</td>
              <td className="p-3 font-mono-ui text-xs text-ink-muted">{formatDateTime(p.created_at)}</td>
            </tr>
          )}
        />
      </Section>
    </>
  );
}

export default function Admin() {
  const [tab, setTab] = useState("overview");
  return (
    <div className="min-h-screen">
      <Header />
      <main id="main" tabIndex={-1} className="max-w-wide mx-auto px-6 md:px-10 py-10">
        <NoticeRegion />
        <div className="marquee-tag mb-2">// ADMIN</div>
        <h1 className="font-display font-black type-title tracking-tighter mb-8">OPERATIONS</h1>

        <Tabs tabs={TABS} active={tab} onChange={setTab} />

        <TabPanel id="overview" active={tab}><Overview /></TabPanel>
        <TabPanel id="users" active={tab}><UsersPanel /></TabPanel>
        <TabPanel id="revenue" active={tab}><RevenuePanel /></TabPanel>
        <TabPanel id="security" active={tab}><SecurityPanel /></TabPanel>
        <TabPanel id="ops" active={tab}><OpsPanel /></TabPanel>
        <TabPanel id="audit" active={tab}><AuditPanel /></TabPanel>
        <TabPanel id="waitlist" active={tab}><WaitlistPanel /></TabPanel>
      </main>
    </div>
  );
}
